import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Axios from '../utils/axios';

function PatientCreate() {
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [tel, setTel] = useState('');
	const [moaref, setMoaref] = useState('');
	const [national_id, setNationalId] = useState('');
	const [birth_date, setBirthDate] = useState('');

	const [disabled, setDisabled] = useState(false);
	const [err, setErr] = useState('');
	const history = useHistory();
	const createPatient = async () => {
		let body = {
			first_name: firstName,
			last_name: lastName,
			moaref,
			tel,
			national_id,
			birth_date
		};
		// remove empty fields
		for (let key in body) {
			if (!body[key]) delete body[key];
		}
		try {
			const res = await Axios.post('/patient/create', body);
			const { data } = res;
			const id = data.id.$oid;
			history.push(`/patient/${id}`);
			setDisabled(true);
		} catch (e) {
			setErr((e.response.data.detail && e.response.data.detail.message) || e.response.data);
			setDisabled(false);
		}
	};

	return (
		<div className="w-11/12 h-full py-3 mx-auto my-2 rounded-md shadow-lg px-7 bg-blue-320">
			<div className="grid grid-cols-2 gap-4 " id="patientForm">
				<TextField label="نام" state={firstName} setState={setFirstName} />
				<TextField label="نام خانوادگی" state={lastName} setState={setLastName} />

				<TextField label="تلفن" state={tel} setState={setTel} />
				<TextField label="معرف" state={moaref} setState={setMoaref} />
				<TextField label="سال تولد" state={birth_date} setState={setBirthDate} type="number" />
				<TextField label="شماره ملی" state={national_id} setState={setNationalId} />
			</div>
			{/* <LongTextField label="PH" state={past_history} setState={setPastHistory} /> */}
			{/* <LongTextField label="DH" state={drug_history} setState={setDrugHistory} /> */}
			{/* <LongTextField label="علت مراجعه" state={description} setState={setDescription} /> */}

			<div className="flex flex-col mx-auto mb-5 ">
				{err && (
					<span className="mx-auto my-3 text-red-600 underline bg-gray-200 rounded shadow-lg">
						{err}
					</span>
				)}

				<button
					className="p-3 mx-auto mt-5 text-white bg-green-800 rounded shadow-lg hover:bg-green-700 disabled:bg-gray-400 "
					disabled={disabled}
					onClick={() => createPatient()}
				>
					ایجاد پرونده
				</button>
			</div>
		</div>
	);
}

function TextField(props) {
	const { state, setState, label } = props;
	return (
		<div className="col-span-1 ">
			{/* <span className="text-lg text-white">{label}: </span>
			<input
				key={label}
				className="h-8 pr-4 placeholder-gray-500 rounded shadow placeholder-opacity-900 md:my-0"
				type="text"
				placeholder={label}
				value={state}
				onChange={(e) => setState(e.target.value)}
			/> */}
			<label
				htmlFor={label}
				className="block mt-2 mb-1 mr-1 text-sm font-medium text-gray-200 dark:text-gray-300"
			>
				{label}
			</label>
			<input
				type={props.type || 'text'}
				id={label}
				className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
				placeholder={label}
				value={state}
				onChange={(e) => setState(e.target.value)}
			/>
		</div>
	);
}
export default PatientCreate;
